import React from 'react';
import './Globe.css';

const Loader = () => {
  return (
    <div className="custom-loader-container">
    <p className="custom-loader-text">
      Codeedex<br />Technologies
    </p>
  </div>
  );
};

export default Loader;
